<ul class="breadcrumb">
    <li><a [routerLink]="['/home']"><span class="color-soft-grey-axial">ESTÁS EN </span>Inicio</a></li>
    <li><i class="pi pi-angle-right"></i></li>
    <li><a [routerLink]="['/configuration/entities']">Configuración</a></li>
    <li><i class="pi pi-angle-right"></i></li>
    <li><a [routerLink]="['/notifications']">Histórico de envíos</a></li>
</ul>
<p-confirmDialog [style]="{width: '50vw'}" [baseZIndex]="10000"></p-confirmDialog>

<!--<app-view #view [code]="'countries.list'" [model]="countriesFilters" (onEvent)="onEvent($event)"></app-view>-->

<div class="p-grid">
    <div class="p-md-12">
        <p-card>
            <ng-template pTemplate="header">
                <div class="p-card-title">
                    Filtros
                    <div class="p-card-title-actions">
                        <a (click)="clearFilters()">Limpiar filtros</a>
                        <a (click)="search()"><i class="fas fa-search"></i>&nbsp;Buscar </a>
                    </div>
                </div>
            </ng-template>
            <div class="p-grid">
                <div class="p-col p-field">
                    <label for="organization_id">Organización</label>
                    <p-dropdown [options]="organizations" [(ngModel)]="filters.organization_id" optionLabel="name"
                        optionValue="id" [filter]="true" filterBy="name" [showClear]="true"
                        placeholder="Selecciona una organización" (onChange)="changeOrganization()" (onFilter)="searchOrganization($event)">
                    </p-dropdown>
                </div>
                <div class="p-col-4 p-field" *ngIf="filters.organization_id != null">
                    <label for="contact_id">Contacto</label>
                    <p-dropdown [options]="contacts" [(ngModel)]="filters.contact_id" optionLabel="name"
                        optionValue="id" [filter]="true" filterBy="name" [showClear]="true"
                        placeholder="Selecciona un contacto">
                    </p-dropdown>
                </div>
                <div class="p-col-12 p-field">
                    <label for="subject">Asunto</label>
                    <input id="subject" type="text" pInputText [(ngModel)]="filters.subject" />
                </div>
                <div class="p-col-4 p-field">
                    <label for="email">Email</label>
                    <input id="email" type="text" pInputText [(ngModel)]="filters.email" />
                </div>
                <div class="p-col p-field">
                    <label for="entity_id">Origen</label>
                    <p-dropdown [options]="entities" [(ngModel)]="filters.entity_id" optionLabel="name"
                        optionValue="id" [filter]="true" filterBy="name" [showClear]="true"
                        placeholder="Selecciona el origen">
                    </p-dropdown>
                </div>
            </div>
        </p-card>

    </div>
    <div class="p-md-12">
        <p-card styleClass="p-card-content-fit">
            <ng-template pTemplate="header">
                <div class="p-card-title">
                    Histórico de emails
                </div>
            </ng-template>
            <p-table #grid [lazy]="true" (onLazyLoad)="loadData($event)" [loading]="loading" [paginator]="true"
                [rows]="10" [totalRecords]="totalRecords" [showCurrentPageReport]="true"
                currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas"
                [rowsPerPageOptions]="[5,10,25,50]" [value]="notificationsEmails" dataKey="name"  paginatorDropdownAppendTo="body"
                responsiveLayout="scroll">
                <ng-template pTemplate="header">
                    <tr>
                        <th pSortableColumn="date">Fecha</th>
                        <th pSortableColumn="subject">Asunto </th>
                        <th pSortableColumn="from">Desde</th>
                        <th pSortableColumn="entity_id">Origen</th>
                        <!--th pSortableColumn="status">Estado </th-->
                        <th width="60px"></th>
                        <!--<th pSortableColumn="attachments">Asunto </th>-->
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-notificationsEmail let-expanded="expanded">
                    <tr (dblclick)="viewMail(notificationsEmail)">
                        <td>
                            {{notificationsEmail.date | date: 'dd/MM/yyyy HH:mm'}}
                            {{notificationsEmail.date ? '':'-'}}
                        </td>
                        <td>{{notificationsEmail.subject}}</td>
                        <td>{{notificationsEmail.from}}</td>
                        <td>{{notificationsEmail.entity?.name}}</td>
                        <!--td [innerHTML]="getState(notificationsEmail.status)"></td-->
                        <td class="grid-actions">
                            <a (click)="resendMail(notificationsEmail)">
                                <fa-icon [icon]="['fas', 'share']"></fa-icon>
                            </a>
                            <a (click)="viewMail(notificationsEmail)">
                                <fa-icon [icon]="['fas', 'eye']"></fa-icon>
                            </a>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </p-card>
    </div>
</div>
